import "./DownloadCard.scss"

import { Link } from "react-router-dom"

interface DownloadCardProps {
  name: string
  version?: string
  releaseDate?: string
  downloadUrl: string
  description?: string
  variant?: "standard" | "package"
  includes?: string[]
  olderVersionsLink?: string
}

function DownloadCard(props: DownloadCardProps) {
  const handleDownload = () => {
    window.open(props.downloadUrl, "_blank")
  }

  return (
    <div className="download-card">
      <div className="download-card__header">
        <h4 className="download-card__name">{props.name}</h4>
        {props.version && (
          <span className="download-card__version">{props.name === "Cropper" ? "v1.0.0" : props.version}</span>
        )}
      </div>

      {props.releaseDate && (
        <div className="download-card__meta">
          <span className="download-card__date">Release Date: {props.releaseDate}</span>
        </div>
      )}

      {props.includes && props.includes.length > 0 && (
        <div className="download-card__includes">
          {props.variant === "package" && props.includes.map((item, index) => (
            <div key={index} className="download-card__includes-item">
              {item}
            </div>
          ))}
        </div>
      )}

      <button
        className="download-card__button"
        onClick={handleDownload}
      >
        Download
      </button>

      {props.olderVersionsLink && (
        <Link to={props.olderVersionsLink} className="download-card__older-versions">
          Older Versions →
        </Link>
      )}
    </div>
  )
}

export default DownloadCard
